export default [
  {
    path: '/submitSuccessTips',
    meta: {
      title: '提交成功'
    },
    component: (resolve) => require(['@/pages/tips/submitSuccessTips'], resolve)
  }
]
